const createField = (config) => config;

const DEVELOPMENT_LOAN_TYPES = [
  "residential development finance",
  "commercial development finance",
];

const isDevelopmentLoan = (data) =>
  DEVELOPMENT_LOAN_TYPES.includes(
    `${data.ProductType || ""}`.trim().toLowerCase()
  );

const isFixedRate = (data) =>
  `${data?.RateType || ""}`.trim().toLowerCase() === "fixed";

const isMarginOverBase = (data) =>
  `${data?.RateType || ""}`.trim().toLowerCase() === "margin over base";

const isHybridMethod = (data) =>
  `${data?.InterestPaymentMethod || ""}`.trim().toLowerCase() === "hybrid";

const MAIN_TABS = [
  "Loan Details",
  "Address Details",
  "Loan Terms",
  "Fees",
  "Cost Details",
  "Risk Rating",
  "Notes",
];

const YES_NO_OPTIONS = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];

export const FIELD_CATALOG = [
  createField({
    backendKey: "LoanName",
    label: "Project Name",
    type: "string",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Parties",
    showOnForm: true,
  }),
  createField({
    backendKey: "BorrowerName",
    label: "Borrower Name",
    type: "lookup",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Parties",
    showOnForm: true,
  }),
  createField({
    backendKey: "KeyPrincipalName",
    label: "Key Principal Name",
    type: "string",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Parties",
    showOnForm: true,
  }),
  createField({
    backendKey: "ExposureGroupName",
    label: "Exposure Group",
    type: "exposure-group-search",
    requiredFlag: "N",
    section: "Loan Details",
    subSection: "Parties",
    showOnForm: false,
  }),
  createField({
    backendKey: "AddressLine1",
    label: "Address Line 1",
    type: "search-string",
    requiredFlag: "Y",
    section: "Address Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "AddressLine2",
    label: "Address Line 2",
    type: "string",
    requiredFlag: "N",
    section: "Address Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "City",
    label: "Town / City",
    type: "string",
    requiredFlag: "Y",
    section: "Address Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "Region",
    label: "Region",
    type: "optionset",
    requiredFlag: "Y",
    section: "Address Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "Postcode",
    label: "Postcode",
    type: "search-string",
    requiredFlag: "Y",
    section: "Address Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "Country",
    label: "Country",
    type: "string",
    requiredFlag: "N",
    defaultValue: "United Kingdom",
    section: "Address Details",
    showOnForm: true,
    disabled: true,
  }),
  createField({
    backendKey: "ProductType",
    label: "Product Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Classification",
    showOnForm: true,
    cols: 1,
  }),
  createField({
    backendKey: "LoanType",
    label: "Loan Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Classification",
    showOnForm: true,
    span: 4,
  }),
  createField({
    backendKey: "LoanPurpose",
    label: "Loan Purpose",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Classification",
    showOnForm: true,
    span: 8,
  }),
  createField({
    backendKey: "DevelopmentType",
    label: "Development Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Classification",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
    span: 6,
  }),
  createField({
    backendKey: "UnitType",
    label: "Unit Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Classification",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
    span: 6,
  }),
  createField({
    backendKey: "LoanSource",
    label: "Loan Source",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Source",
    showOnForm: true,
    span: 7,
  }),
  createField({
    backendKey: "LeadSourceDetail",
    label: "Lead Source Detail",
    type: "string",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Source",
    showOnForm: true,
    span: 5,
  }),
  // createField({
  //   backendKey: "AccountReferenceNumber",
  //   label: "Account Reference Number",
  //   type: "string",
  //   requiredFlag: "N",
  //   section: "Loan Details",
  //   subSection: "Source",
  //   showOnForm: true,
  //   span: 6,
  // }),
  createField({
    backendKey: "MigrationIndicator",
    label: "Migration Indicator",
    type: "optionset",
    requiredFlag: "N",
    section: "Loan Details",
    subSection: "Source",
    showOnForm: true,
    span: 4,
    fixedOptions: YES_NO_OPTIONS,
  }),
  createField({
    backendKey: "SecurityTenureType",
    label: "Security Tenure Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Classification",
    showOnForm: true,
  }),
  createField({
    backendKey: "CustomerType",
    label: "Customer Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Classification",
    showOnForm: true,
  }),
  createField({
    backendKey: "Currency",
    label: "Currency",
    type: "optionset",
    requiredFlag: "Y",
    defaultValue: "GBP",
    section: "Loan Details",
    subSection: "Classification",
    showOnForm: true,
  }),
  createField({
    backendKey: "BusinessDevelopmentManager",
    label: "Business Development Manager",
    type: "lookup",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Deal Team",
    showOnForm: true,
    span: 6,
  }),
  createField({
    backendKey: "LendingDirector",
    label: "Lending Director",
    type: "lookup",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Deal Team",
    showOnForm: true,
    span: 6,
  }),
  createField({
    backendKey: "RelationshipManager",
    label: "Relationship Manager",
    type: "lookup",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Deal Team",
    showOnForm: true,
    span: 6,
  }),
  createField({
    backendKey: "PortfolioManager",
    label: "Portfolio Manager",
    type: "lookup",
    requiredFlag: "Y",
    section: "Loan Details",
    subSection: "Deal Team",
    showOnForm: true,
    span: 6,
  }),
  createField({
    backendKey: "DrawdownDistributionType",
    label: "Drawdown Distribution Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Terms",
    subSection: "Facility",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "AOTLimit",
    label: "AOT Limit",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Loan Terms",
    subSection: "Facility",
    showOnForm: true,
  }),
  createField({
    backendKey: "LoanTerm",
    label: "Loan Term",
    type: "integer",
    requiredFlag: "Y",
    validationRule: ">= 0.",
    section: "Loan Terms",
    subSection: "Facility",
    showOnForm: true,
  }),
  createField({
    backendKey: "ProjectStartDate",
    label: "Project Start Date",
    type: "date",
    requiredFlag: "Y",
    section: "Loan Terms",
    subSection: "Key Dates",
    showOnForm: true,
    helperText: "DD/MM/YYYY",
  }),
  createField({
    backendKey: "BuildStartDate",
    label: "Build Start Date",
    type: "date",
    requiredFlag: "Y",
    section: "Loan Terms",
    subSection: "Key Dates",
    showOnForm: true,
    helperText: "DD/MM/YYYY",
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "PracticalCompletionDate",
    label: "Practical Completion Date",
    type: "date",
    requiredFlag: "Y",
    section: "Loan Terms",
    subSection: "Key Dates",
    showOnForm: true,
    helperText: "DD/MM/YYYY",
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "SaleVoidDays",
    label: "Sale Void Days",
    type: "integer",
    requiredFlag: "N",
    validationRule: ">= 0.",
    defaultValue: 30,
    section: "Loan Terms",
    subSection: "Facility",
    showOnForm: true,
  }),
  createField({
    backendKey: "RateType",
    label: "Rate Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Terms",
    subSection: "Interest & Rate",
    showOnForm: true,
    span: 4,
  }),
  createField({
    backendKey: "SVR",
    label: "SVR",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Loan Terms",
    subSection: "Interest & Rate",
    showOnForm: true,
    visibleWhen: isMarginOverBase,
    span: 4,
  }),
  createField({
    backendKey: "FixedRate",
    label: "Fixed Rate",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Loan Terms",
    subSection: "Interest & Rate",
    showOnForm: true,
    visibleWhen: isFixedRate,
    span: 4,
  }),
  createField({
    backendKey: "MarginRate",
    label: "Margin Rate",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Loan Terms",
    subSection: "Interest & Rate",
    showOnForm: true,
    visibleWhen: isMarginOverBase,
    span: 4,
  }),
  createField({
    backendKey: "DayCountBasis",
    label: "Day Count Basis",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Terms",
    subSection: "Interest & Rate",
    showOnForm: true,
    span: 4,
  }),
  createField({
    backendKey: "InterestPaymentMethod",
    label: "Interest Payment Method",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Terms",
    subSection: "Interest & Rate",
    showOnForm: true,
    span: 8,
  }),

  createField({
    backendKey: "ArrangementFeeRate",
    label: "Arrangement Fee (%)",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "arrangementFee",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "ArrangementFeeAmount",
    label: "Arrangement Fee (Amount)",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "arrangementFee",
    feeModeValue: "amount",
  }),
  createField({
    backendKey: "ArrangementFeePaymentMethod",
    label: "Arrangement Fee Payment Method",
    type: "optionset",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "arrangementFee",
  }),
  createField({
    backendKey: "CommitmentFeeRate",
    label: "Commitment Fee (%)",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: false,
    feeModeGroup: "commitmentFee",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "CommitmentFeeAmount",
    label: "Commitment Fee (Amount)",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "N",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "commitmentFee",
    feeModeValue: "amount",
  }),
  createField({
    backendKey: "ExitFeeRate",
    label: "Exit Fee (%)",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "N",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "exitFee",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "ExitFeeAmount",
    label: "Exit Fee (Amount)",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "N",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "exitFee",
    feeModeValue: "amount",
  }),
  createField({
    backendKey: "ExitStrategy",
    label: "Exit Strategy",
    type: "optionset",
    requiredFlag: "N",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "exitFee",
  }),
  createField({
    backendKey: "BrokerFeeRate",
    label: "Broker Fee Rate",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "brokerFee",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "BrokerFeeAmount",
    label: "Broker Fee Amount",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "brokerFee",
    feeModeValue: "amount",
  }),
  createField({
    backendKey: "BrokerFeePaymentMethod",
    label: "Broker Fee Payment Method",
    type: "optionset",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "brokerFee",
  }),
  createField({
    backendKey: "ValuationFeeRate",
    label: "Valuation Fee Rate",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: false,
    feeModeGroup: "valuationFee",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "ValuationFeeAmount",
    label: "Valuation Fee Amount",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "valuationFee",
    feeModeValue: "amount",
  }),
  createField({
    backendKey: "ValuationFeePaymentMethod",
    label: "Valuation Fee Payment Method",
    type: "optionset",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "valuationFee",
  }),
  createField({
    backendKey: "LenderFeeRate",
    label: "Lender Legal Fee Rate",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: false,
    feeModeGroup: "lenderFee",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "LenderFeeAmount",
    label: "Lender Legal Fee Amount",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "lenderFee",
    feeModeValue: "amount",
  }),
  createField({
    backendKey: "LenderFeePaymentMethod",
    label: "Lender Legal Fee Payment Method",
    type: "optionset",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: false,
    feeModeGroup: "lenderFee",
  }),
  createField({
    backendKey: "ExtensionFeeRate",
    label: "Extension Fee Rate",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "N",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "extensionFee",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "ExtensionFeeAmount",
    label: "Extension Fee Amount",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "N",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "extensionFee",
    feeModeValue: "amount",
  }),
  createField({
    backendKey: "ExtensionOptions",
    label: "Extension Options",
    type: "text",
    multiline: true,
    rows: 3,
    section: "Notes",
    required: "N",
    showOnForm: true,
    fullWidth: true,
  }),
  createField({
    backendKey: "RepaymentProfile",
    label: "Repayment Profile",
    type: "optionset",
    requiredFlag: "N",
    section: "Loan Terms",
    subSection: "Repayment",
    showOnForm: true,
  }),
  createField({
    backendKey: "BrokerNotes",
    label: "Broker / Applicant Notes",
    type: "text",
    multiline: true,
    rows: 4,
    section: "Notes",
    required: "N",
    showOnForm: true,
    fullWidth: true,
  }),
  createField({
    backendKey: "PriorityStatus",
    label: "Priority Status",
    type: "optionset",
    requiredFlag: "N",
    section: "Loan Terms",
    subSection: "Repayment",
    showOnForm: true,
  }),
  createField({
    backendKey: "MarketValuation",
    label: "Market Valuation",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "N",
    section: "Loan Terms",
    subSection: "Repayment",
    showOnForm: true,
  }),
  createField({
    backendKey: "ServicedAmount",
    label: "Serviced Amount",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "N",
    section: "Loan Terms",
    subSection: "Interest & Rate",
    showOnForm: true,
    visibleWhen: isHybridMethod,
    feeModeGroup: "servicedHybrid",
    feeModeValue: "amount",
  }),
  createField({
    backendKey: "ServicedRate",
    label: "Serviced Rate",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "N",
    section: "Loan Terms",
    subSection: "Interest & Rate",
    showOnForm: true,
    visibleWhen: isHybridMethod,
    feeModeGroup: "servicedHybrid",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "CreatedBy",
    label: "Created By",
    type: "string",
    showOnForm: false,
  }),
  createField({
    backendKey: "PurchasePrice",
    label: "Purchase Price",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Land",
    showOnForm: true,
  }),
  createField({
    backendKey: "AmountSpentSincePurchase",
    label: "Funds Spent On Site Since Purchase",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Land",
    showOnForm: true,
  }),
  createField({
    backendKey: "StampDutyPercent",
    label: "Stamp Duty",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Land",
    showOnForm: true,
  }),
  createField({
    backendKey: "DemoAndInfrastructure",
    label: "Demo & Infrastructure",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Construction",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "EquitySpentByBorrowerOnConstruction",
    label: "Borrower's Equity To Be Spent On Build",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Construction",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "MainBuild",
    label: "Main Build",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Unit Construction",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "ContingencyPercent",
    label: "Contingency (% of Main Build)",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Unit Construction",
    showOnForm: true,
  }),

  createField({
    backendKey: "ProfessionalFees",
    label: "Professional Fees",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Professional Fees",
    showOnForm: true,
  }),
  createField({
    backendKey: "OtherFees",
    label: "Others",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Professional Fees",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "UtilityFees",
    label: "Utilities",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Professional Fees",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "NewBuildWarranty",
    label: "New Build Warranty",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Professional Fees",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "CommunityInfrastructureLevyFees",
    label: "S106/CIL",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Professional Fees",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "BankIMS",
    label: "Bank IMS",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Professional Fees",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "MarketingFees",
    label: "Marketing",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Marketing",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "Legal1PurchaseCost",
    label: "Legal 1 Cost",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Purchase Costs",
    showOnForm: true,
  }),
  createField({
    backendKey: "Legal2PurchaseCost",
    label: "Legal 2 Cost",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Purchase Costs",
    showOnForm: true,
  }),
  createField({
    backendKey: "OverheadCost",
    label: "Overhead Cost",
    type: "float",
    validationRule: ">= 0.",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Site Overheads",
    showOnForm: true,
  }),
  createField({
    backendKey: "RiskStatus",
    label: "Risk Status",
    type: "optionset",
    requiredFlag: "N",
    defaultValue: "Low",
    section: "Risk Rating",
    showOnForm: true,
  }),
];

export const LOAN_STEPS = MAIN_TABS.map((title) => ({
  title,
  fields: FIELD_CATALOG.filter(
    (field) => field.showOnForm && field.section === title
  ),
})).filter((step) => step.fields.length > 0);

export const ALL_FIELDS = FIELD_CATALOG;

export const PERCENTAGE_FIELD_KEYS = [
  "SVR",
  "FixedRate",
  "MarginRate",
  "ArrangementFeeRate",
  "ExitFeeRate",
  "BrokerFeeRate",
  "ValuationFeeRate",
  "LenderFeeRate",
  "ContingencyPercent",
  "StampDutyPercent",
];

export const CHIP_SELECT_FIELD_KEYS = [
  "ProductType",
  "PriorityStatus",
  "DrawdownDistributionType",
  "LoanType",
  "LoanPurpose",
  "LoanSource",
  "MigrationIndicator",
  "SecurityTenureType",
  "CustomerType",
  "Currency",
  "RateType",
  "DayCountBasis",
  "InterestPaymentMethod",
  "RepaymentProfile",
  "ExitStrategy",
  "BrokerFeePaymentMethod",
  "ValuationFeePaymentMethod",
  "RiskStatus",
  "ArrangementFeePaymentMethod",
];

export const DEFAULT_FIELD_COLS = 3;

const COLS_TO_GRID = {
  1: { xs: 12, sm: 12, md: 12 },
  2: { xs: 12, sm: 6, md: 6 },
  3: { xs: 12, sm: 6, md: 4 },
};

export const isChipSelectField = (field) =>
  CHIP_SELECT_FIELD_KEYS.includes(field.backendKey) &&
  (field.type === "optionset" || field.type === "boolean");

/**
 * Resolve the responsive grid span for a field.
 * @param {object} field  Catalog field config.
 * @returns {{xs:number, sm:number, md:number}}
 */
export const getFieldGridSize = (field) => {
  // Explicit 12-column span wins — lets a row use uneven splits.
  if (field.span) {
    const md = Math.min(12, Math.max(1, field.span));
    return { xs: 12, sm: 12, md };
  }

  let cols = field.cols;

  if (!cols) {
    cols = field.fullWidth || field.multiline ? 1 : DEFAULT_FIELD_COLS;
  }

  return COLS_TO_GRID[cols] || COLS_TO_GRID[DEFAULT_FIELD_COLS];
};

export const LEGACY_KEY_MAP = {
  LoanName: "loanName",
  BorrowerName: "borrowerName",
  KeyPrincipalName: "keyPrincipalName",
  ExposureGroupName: "exposuregroupname",
  AddressLine1: "addressLine1",
  AddressLine2: "addressLine2",
  City: "city",
  Postcode: "postcode",
  Country: "country",
  Region: "region",
  ProductType: "productType",
  LoanType: "loanType",
  LoanPurpose: "loanPurpose",
  DevelopmentType: "developmentType",
  UnitType: "unitType",
  LoanSource: "loanSource",
  LeadSourceDetail: "leadSourceDetail",
  AccountReferenceNumber: "accountReferenceNumber",
  MigrationIndicator: "migrationIndicator",
  SecurityTenureType: "securityTenureType",
  CustomerType: "customerType",
  Currency: "currency",
  BusinessDevelopmentManager: "businessDevelopmentManager",
  LendingDirector: "lendingDirector",
  RelationshipManager: "relationshipManager",
  PortfolioManager: "portfolioManager",
  DrawdownDistributionType: "drawdownDistributionType",
  AOTLimit: "aotLimit",
  LoanTerm: "loanTerm",
  ProjectStartDate: "projectStartDate",
  BuildStartDate: "buildStartDate",
  PracticalCompletionDate: "practicalCompletionDate",
  SVR: "svr",
  RateType: "rateType",
  FixedRate: "fixedRate",
  MarginRate: "marginRate",
  DayCountBasis: "dayCountBasis",
  InterestPaymentMethod: "interestPaymentMethod",
  ArrangementFeeRate: "arrangementFeeRate",
  ArrangementFeeAmount: "arrangementFeeAmount",
  ArrangementFeePaymentMethod: "arrangementFeePaymentMethod",
  CommitmentFeeAmount: "commitmentFeeAmount",
  ExitFeeRate: "exitFeeRate",
  ExitFeeAmount: "exitFeeAmount",
  ExitStrategy: "exitStrategy",
  BrokerFeeRate: "brokerFeeRate",
  BrokerFeeAmount: "brokerFeeAmount",
  BrokerFeePaymentMethod: "brokerFeePaymentMethod",
  ValuationFeeRate: "valuationFeeRate",
  ValuationFeeAmount: "valuationFeeAmount",
  ValuationFeePaymentMethod: "valuationFeePaymentMethod",
  LenderFeeRate: "lenderFeeRate",
  LenderFeeAmount: "lenderFeeAmount",
  LenderFeePaymentMethod: "lenderFeePaymentMethod",
  RepaymentProfile: "repaymentProfile",
  BrokerNotes: "brokerNotes",
  PriorityStatus: "priorityStatus",
  CreatedBy: "createdBy",
  PurchasePrice: "purchasePrice",
  AmountSpentSincePurchase: "amountSpentSincePurchase",
  StampDutyPercent: "stampDutyPercent",
  DemoAndInfrastructure: "demoAndInfrastructure",
  EquitySpentByBorrowerOnConstruction: "equitySpentByBorrowerOnConstruction",
  MainBuild: "mainBuild",
  ContingencyPercent: "contingencyPercent",
  ProfessionalFees: "professionalFees",
  OtherFees: "otherFees",
  UtilityFees: "utilityFees",
  NewBuildWarranty: "newBuildWarranty",
  CommunityInfrastructureLevyFees: "communityInfrastructureLevyFees",
  BankIMS: "bankIMS",
  MarketingFees: "marketingFees",
  RiskStatus: "riskStatus",
};

export const FEE_MODE_OPTIONS = [
  { label: "Rate", value: "rate" },
  { label: "Amount", value: "amount" },
];

export const FEE_MODE_DEFAULTS = {
  arrangementFee: "rate",
  exitFee: "rate",
  commitmentFee: "amount",
  monitoringFee: "rate",
  brokerFee: "rate",
  valuationFee: "amount",
  lenderFee: "amount",
  servicedHybrid: "rate",
};

export const FEE_GROUPS = [
  { key: "arrangementFee", title: "Arrangement Fee" },
  { key: "commitmentFee", title: "Commitment Fee" },
  { key: "brokerFee", title: "Broker Fee" },
  { key: "valuationFee", title: "Valuation Fee" },
  { key: "lenderFee", title: "Lender Legal Fee" },
  { key: "monitoringFee", title: "Monitoring Fee" },
  { key: "exitFee", title: "Exit Fee" },
];

export const DEVELOPER_AUTOFILL_EMAILS = [
  "shubham.saini@equipped.ai",
  "murari.aggarwal@equipped.ai",
  "pallavi.saini@equipped.ai",
  "tanmay.sheoran@equipped.ai",
];
